
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[subpage]",
      function () {
        return require("private-next-pages/[subpage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[subpage]"])
      });
    }
  